module.exports = __webpack_public_path__ + "images/shoebox1-1d769a570772199a09fe793d1675d720.jpg";